import { render, staticRenderFns } from "./ReferencesHome.vue?vue&type=template&id=15b51b34&scoped=true&"
import script from "./ReferencesHome.vue?vue&type=script&lang=js&"
export * from "./ReferencesHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b51b34",
  null
  
)

export default component.exports